/* unplugin-vue-components disabled */import { render } from "./member_shou_m.vue?vue&type=template&id=5774306f&scoped=true"
import script from "./member_shou_m.vue?vue&type=script&lang=js"
export * from "./member_shou_m.vue?vue&type=script&lang=js"

import "./member_shou_m.vue?vue&type=style&index=0&id=5774306f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5774306f"]])

export default __exports__